import Konva from '../plugins/konva.min';

export default {
    template: document.querySelector('[data-quiz-map-template]') ?
        document.querySelector('[data-quiz-map-template]').innerHTML:
        null,
    props: {
        questions: {
            type: Array,
        },
        extra: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            map: null,
            mapImageLayer: null,
            mapDotLayer: null,
            mapMayaLayer: null,
            appWidth: null,
            appHeight: null,
            badges: badges,

            // Maya properties
            maya: null,
            mayaFlying: false,
            mayaMirrored: false,
            mayaLastVisited: null,
            mayaWing1: null,
            mayaWing2: null,

            showStartScreen: true,
            destroyStartScreen: false,

            mayaGifCanvas: null,

            mayaLoaded: false,
            wing1Loaded: false,
            wing2Loaded: false,
            mapLoaded: false
        };
    },
    computed: {
        mayaComplete() {
            return this.mayaLoaded && this.wing1Loaded && this.wing2Loaded && this.mapLoaded;
        }
    },
    watch: {
        mayaMirrored() {
            this.maya.to({
                scaleX: -this.maya.scaleX(),
            });
        },
        mayaComplete() {
            if (this.mayaComplete) {
                this.mapMayaLayer.add(this.maya);
                this.map.add(this.mapMayaLayer);
                this.mapMayaLayer.draw();

                // this.mayaWing1.offsetX(0);
                // this.mayaWing1.offsetY(this.mayaWing1.height());

                // const angularSpeed = 90;
                // const animation = new Konva.Animation((frame) => {
                //     const angleDiff = (frame.timeDiff * angularSpeed) / 1000;
                //     this.mayaWing1.rotate(angleDiff);
                // }, this.mapMayaLayer);
                //
                // animation.start();
            }
        }
    },
    methods: {

        /**
         * Start the game, ah yes!
         */
        startGame() {
            this.$refs.startScreen.addEventListener('animationend', () => {
                this.destroyStartScreen = true;
                this.$emit('start-game');
            });

            this.showStartScreen = false;
        },

        /**
         * Create our map
         * We add 2 layers to the Konva canvas:
         * - we have a layer that contains our question 'dots'
         * - and we have a layer that contains maya
         */
        initializeMap() {
            // check the width of the app
            this.appWidth  = this.$el.clientWidth;
            this.appHeight = this.appWidth * 0.5625;

            // make sure the playing area doesn't go below the fold
            const screenHeight = window.innerHeight;
            if (this.appHeight > screenHeight) {
                this.appHeight = screenHeight;
            }

            // create the Konva canvas
            this.map = new Konva.Stage({
                container: 'quiz-canvas-wrap',
                width: this.appWidth,
                height: this.appHeight
            });

            // create layer for images
            this.mapImageLayer = new Konva.Layer();

            // add background to map
            Konva.Image.fromURL(mapImage, (mapImageNode) => {
                mapImageNode.setAttrs({
                    x: 0,
                    y: 0,
                    width: this.appWidth,
                    height: this.appHeight
                });
                this.mapImageLayer.add(mapImageNode);
            });

            // create question dot layer
            this.mapDotLayer = new Konva.Layer();
            this.questions.forEach((question, index) => {
                this.createQuizDot(question.id, index);
            });

            // create maya layer
            this.createMayaLayer();

            // draw question dot layer
            this.map.add(this.mapImageLayer);
            this.mapImageLayer.draw();

            // draw question dot layer
            this.map.add(this.mapDotLayer);
            this.mapDotLayer.draw();

            // draw maya layer
            this.map.add(this.mapMayaLayer);
            this.mapMayaLayer.draw();
            this.mapLoaded = true;
        },

        /**
         * Create a dot for every question
         *
         * @param questionId
         * @param index
         */
        createQuizDot(questionId, index) {
            let x, y;
            const question = this.questions.find(x => x.id === questionId);
            const extra = this.extra[questionId];
            const isLockedQuestion = this.extra[questionId].locked;

            if (extra && extra.position && extra.position.x !== null && extra.position.y !== null) {
                x = this.appWidth * (extra.position.x / 100);
                y = this.appHeight * (extra.position.y / 100);
            } else {
                x = Math.floor(Math.random() * this.appWidth);
                y = Math.floor(Math.random() * this.appHeight);
            }
            if (question.image) {
                Konva.Image.fromURL(question.image, (dot) => {
                    const imageHeightFactor = dot.attrs.image.width / dot.attrs.image.height;
                    const height  = this.appHeight * 0.28;
                    const width = height * imageHeightFactor;

                    dot.setAttrs({
                        x: x ,
                        y: y,
                        width: width,
                        height: height,
                        id: questionId,
                    });

                    if (isLockedQuestion) {
                        dot.offsetX(dot.width());
                    } else {
                        dot.offsetX(dot.width() / 2);
                        dot.offsetY(dot.width() / 2);
                    }

                    dot.on('click', () => {
                        this.handleDotFlying(x - (width * 0.75), y + (height / 4), questionId);
                    });
                    dot.on('tap', () => {
                        this.handleDotFlying(x - (width * 0.75), y + (height / 4), questionId);
                    });

                    this.createDotHoverStates(dot, ! isLockedQuestion);
                    this.mapDotLayer.add(dot);

                    // add pulsing to locked dots
                    if (isLockedQuestion) {
                        const amplitude = 0.025;
                        const period = 2500;

                        const animation = new Konva.Animation((frame) => {
                            dot.scaleX(
                                amplitude * Math.sin((frame.time * 2 * Math.PI) / period) + 1
                            );
                            dot.scaleY(
                                amplitude * Math.sin((frame.time * 2 * Math.PI) / period) + 1
                            );
                        }, this.mapDotLayer);
                        animation.start();
                    }

                    this.addBadgeToDot(questionId, index, x, y, width, height);
                });
            } else {
                const width = this.appWidth * 0.05;

                const dot = new Konva.Circle({
                    x: x,
                    y: y,
                    radius: width,
                    fill: '#F9B83E',
                    id: questionId
                });

                dot.on('click', () => {
                    this.handleDotFlying(x, y, questionId);
                });

                dot.on('tap', () => {
                    this.handleDotFlying(x, y, questionId);
                });

                this.createDotHoverStates(dot);
                this.mapDotLayer.add(dot);

                this.addBadgeToDot(questionId, index, x, y, dot.width(), dot.height());
            }
        },

        addBadgeToDot(questionId, index, x, y, dotWidth, dotHeight) {
            const badgesForDot = this.badges[index + 1];
            if (badgesForDot) {
                Konva.Image.fromURL(this.badges[index + 1].default, (badge) => {
                    const dimensions  = this.appHeight * 0.075;

                    badge.setAttrs({
                        x: x - dotWidth / 2,
                        y: y - (dotHeight / 2) + (badge.height() / 2),
                        width: dimensions,
                        height: dimensions,
                        id: questionId + 'badge',
                        listening: false
                    });

                    // badge.offsetX(badge.width());

                    this.mapDotLayer.add(badge);
                });
            }
        },

        /**
         * Central method to trigger Maya to start flying
         * @param x
         * @param y
         * @param questionId
         */
        handleDotFlying(x, y, questionId) {
            // only move if Maya is not moving yet
            if (! this.mayaFlying) {
                if (this.mayaLastVisited === questionId) {
                    this.$emit('question-selected', questionId);
                    return;
                }

                this.moveMaya(x, y, questionId);
            }
        },

        /**
         * Make sure shapes appear clickable on hover
         * @param dot
         * @param scale = true
         */
        createDotHoverStates(dot, scale = true) {

            dot.on('mouseover', (environment) => {
                const dotShape = environment.target;
                document.body.style.cursor = 'pointer';
                if (scale) {
                    // time for tweening!
                    const tween = new Konva.Tween({
                        node: dotShape,
                        duration: 0.28,
                        scaleX: 1.1,
                        scaleY: 1.1,
                        easing: Konva.Easings.EaseInOut,
                        onFinish: () => {
                            // destroy tween to save on performance
                            tween.destroy();
                        }
                    });

                    // dotShape.scaleX(1.05);
                    // dotShape.scaleY(1.05);
                    tween.play();
                }
            });
            dot.on('mouseout', (environment) => {
                const dotShape = environment.target;
                document.body.style.cursor = 'default';
                if (scale) {
                    // time for tweening!
                    const tween = new Konva.Tween({
                        node: dotShape,
                        duration: 0.28,
                        scaleX: 1,
                        scaleY: 1,
                        easing: Konva.Easings.EaseInOut,
                        onFinish: () => {
                            // destroy tween to save on performance
                            tween.destroy();
                        }
                    });

                    // dotShape.scaleX(1);
                    // dotShape.scaleY(1);
                    tween.play();
                }
            });
        },

        /**
         * Create the Maya layer on which Maya will be flying around
         */
        createMayaLayer() {
            this.mapMayaLayer = new Konva.Layer();

            // const canvas = document.createElement('canvas');
            // this.maya = canvas;
            // gifler(mayaImage).frames(canvas, this.onDrawFrame);
            //
            // const image = new Konva.Image({
            //     image: canvas,
            // });
            // this.mapMayaLayer.add(image);

            // this.maya = new Konva.Group({
            //     x: this.appWidth / 8,
            //     y: 10,
            //     width: 100,
            //     height: 100,
            //     fill: '#ffffff'
            // });

            // const wing1ImageObject = new Image();
            // wing1ImageObject.onload = () => {
            //     const imageHeightFactor = mayaImageObject.width / mayaImageObject.height;
            //     const height  = this.appHeight * 0.1;
            //     const width = height * imageHeightFactor;
            //
            //     const mayaWing1 = new Konva.Image({
            //         x: width / 4,
            //         y: height,
            //         image: wing1ImageObject,
            //         width: width,
            //         height: height,
            //     });
            //
            //     // add the shape to the layer
            //     this.maya.add(mayaWing1);
            //     this.wing1Loaded = true;
            // };
            // wing1ImageObject.src = mayaWing1Image;
            //
            // const wing2ImageObject = new Image();
            // wing2ImageObject.onload = () => {
            //     const imageHeightFactor = mayaImageObject.width / mayaImageObject.height;
            //     const height  = this.appHeight * 0.1;
            //     const width = height * imageHeightFactor;
            //
            //     const mayaWing2 = new Konva.Image({
            //         x: width / 4,
            //         y: height,
            //         image: wing2ImageObject,
            //         width: width,
            //         height: height,
            //     });
            //
            //     // add the shape to the layer
            //     this.maya.add(mayaWing2);
            //     this.wing2Loaded = true;
            // };
            // wing2ImageObject.src = mayaWing2Image;

            const mayaImageObject = new Image();
            mayaImageObject.onload = () => {
                const imageHeightFactor = mayaImageObject.width / mayaImageObject.height;
                const height  = this.appHeight * 0.32;
                const width = height * imageHeightFactor;

                this.maya = new Konva.Image({
                    x: this.appWidth / 8,
                    y: 10,
                    image: mayaImageObject,
                    width: width,
                    height: height,
                    listening: false
                });

                this.maya.offsetX(this.maya.width() / 2);

                // add the shape to the layer
                // this.maya.add(this.maya);
                this.mapMayaLayer.add(this.maya);
                this.mayaLoaded = true;
            };
            mayaImageObject.src = mayaImage;
        },

        // onDrawFrame(ctx, frame) {
        //     // update canvas size
        //     this.maya.width = 104;
        //     this.maya.height = 150;
        //     // update canvas that we are using for Konva.Image
        //     ctx.drawImage(frame.buffer, 0, 0);
        //     // redraw the layer
        //     this.mapMayaLayer.draw();
        // },

        /**
         * Calculate a path to a clicked location on the canvas and create a tween to move Maya to the click location
         * @param x
         * @param y
         * @param questionId
         */
        moveMaya(x, y, questionId) {
            this.mayaFlying = true;

            // calculate the amount of time it has to take for Maya to travel to the new dot
            let durationX = Math.floor(x - this.maya.attrs.x);
            let durationY = Math.floor(y - this.maya.attrs.y);

            // make sure we're working with positive numbers
            if (durationX < 0) {
                durationX = -durationX;
            }
            if (durationY < 0) {
                durationY = -durationY;
            }

            // calculate total duration
            let totalDuration = (durationX + durationY);

            // also add bounds
            if (totalDuration > 500) {
                totalDuration = 500;
            } else if (totalDuration < 200) {
                totalDuration = 200;
            }

            // calculate the target to fly towards
            const isLockedQuestion = this.extra[questionId].locked;
            const flyTargetOffsetX = isLockedQuestion ? 0 : (this.maya.width() / 2);
            const flyTargetOffsetY = isLockedQuestion ? 0 : (this.maya.height() / 2);

            const targetX = x + flyTargetOffsetX + 24;
            const targetY = y - flyTargetOffsetY;

            if (targetX > this.maya.attrs.x && ! this.mayaMirrored) {
                this.mayaMirrored = true;
            } else if (targetX < this.maya.attrs.x && this.mayaMirrored) {
                this.mayaMirrored = false;
            }

            // time for tweening!
            const tween = new Konva.Tween({
                node: this.maya,
                duration: totalDuration / 250,
                x: targetX,
                y: targetY,
                easing: Konva.Easings.EaseInOut,
                onFinish: () => {
                    this.$emit('question-selected', questionId);

                    // destroy tween to save on performance
                    tween.destroy();
                    this.mayaFlying = false;
                    this.mayaLastVisited = questionId;
                }
            });

            // fly away :3
            tween.play();
        },

        /**
         * Mark the dot as completed by replacing the badge with a green one
         * @param questionId
         */
        completeQuestionDot(questionId) {
            const badge = this.map.find('#' + questionId + 'badge');
            const completedBadge = Object.values(this.badges).find(x => x.default === badge[0].attrs.image.src);

            const completeBadgeImageObject = new Image();
            completeBadgeImageObject.onload = () => {
                const completedBadgeImage = new Konva.Image({
                    x: badge[0].attrs.x,
                    y: badge[0].attrs.y,
                    image: completeBadgeImageObject,
                    width: badge[0].width(),
                    height: badge[0].height(),
                    listening: false
                });

                // completedBadgeImage.offsetX(completedBadgeImage.width());

                // add the shape to the layer
                this.mapDotLayer.add(completedBadgeImage);
            };
            completeBadgeImageObject.src = completedBadge.complete;

            // questionDot.fill('#2DB535');
        },

        /**
         * Unlock all locked questions
         */
        activateLockedQuestions() {
            Object.keys(this.extra).forEach(questionId => {
                if (this.extra[questionId].locked) {
                    const questionDot = this.map.findOne('#' + questionId);
                    questionDot.on('click', () => {
                        if (! this.mayaFlying) {
                            this.moveMaya(questionDot.attrs.x, questionDot.attrs.y, questionId);
                        }
                    });
                    questionDot.fill('blue');
                }
            });
        },

        /**
         * Rescaling the map
         */
        fitStageIntoParentContainer() {
            const container = this.$refs.mapWrap;
            this.appWidth   = container.clientWidth;
            this.appHeight  = this.appWidth / 2;

            // now we need to fit stage into parent container
            const containerWidth = container.offsetWidth;

            // but we also make the full scene visible
            // so we need to scale all objects on canvas
            const scale = containerWidth / this.appWidth;

            this.map.width(this.appWidth * scale);
            this.map.height(this.appHeight * scale);
            this.map.scale({ x: scale, y: scale });
        }
    },
    mounted() {
        this.initializeMap();
        window.addEventListener('resize', () => {
            this.fitStageIntoParentContainer();
        });
    }
}